export default {
  title: {
    preference: '我的偏好',
    surveyQuestion: '问卷问题',
    survey: {
      candidate: '求职者问卷',
      employee: '员工问卷'
    },
    lastStep: '谢谢！'
  },
  label: {
    notification: '职位提醒推送方式',
    frequency: '职位提醒推送频率',
    followUs: '现在，最后一步是，请关注我们的微信，这样您就可以第一时间了解为您量身定制的激动人心的机会。',
    getNews: '自动获取职位提醒以及职业新闻!',
    submitResume: '提交/编辑简历',
    jobAlertTip: '加入我们的人才社区！',
    jobAlertContent: [
      '加入我们的人才社区，即可根据您的技能和兴趣，获得个性化职位提醒。\n',
      '您还将及时了解我们最新的职业机会、公司动态和活动信息。\n',
      '只需两分钟，即可完成以下操作：'
    ].join('\n'),
    jobAlertContentFooter: '当有职位、活动或更新与您的个人资料匹配时，我们会第一时间通知您——确保您不错过任何适合您的机会。',
    jobAlertLoginList: [
      '填写您的兴趣偏好',
      '上传或创建您的简历'
    ],
    jobAlertNoLoginList: [
      '注册账号',
      '填写您的兴趣偏好',
      '上传或创建您的简历'
    ],
    viewMyPreferredJobs: '查看我的偏好职位'
  },
  message: {
    saveSuccess: '保存成功！',
    noAnswerQuestion: '该字段不能为空。'
  },
  menu: {
    home: '首页'
  },
  btn: {
    goQuestion: {
      new: '去回答',
      modify: '去修改'
    },
    back: '返回',
    next: '下一题',
    finish: '完成',
    save: '保存',
    continue: '继续'
  },
  notificationType: {
    wechat: '微信',
    email: '邮件',
    both: '微信和邮件'
  },
  frequency: {
    weekly: '每周',
    monthly: '每月',
    off: '关闭'
  },
  questionType: {
    dropdown: '单选',
    checkbox: '多选'
  },
  step: {
    register: '注册',
    survey: '偏好问卷',
    submitResume: '提交/编辑简历'
  }
}
